/**
 * Pull the visualizations array out of an AI response payload.
 *
 * The sync endpoint, the SSE `complete` frame and the cached replay have each
 * nested this field differently over time, and a mismatch fails silently: the
 * message renders as text while the chart it refers to never appears. Checking
 * the known shapes keeps the chat working regardless of which one arrives.
 */
export const extractVisualizations = (payload) => {
  if (!payload || typeof payload !== 'object') return [];

  const candidates = [
    payload.visualizations,
    payload.data?.visualizations,
    payload.result?.visualizations,
    payload.data?.data?.visualizations,
  ];

  const found = candidates.find((c) => Array.isArray(c) && c.length > 0);
  return found || [];
};

export default extractVisualizations;
